import * as React from "react";
import type { SVGProps } from "react";
const SvgChartIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="chart_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M256 85.333A170.667 170.667 0 0 0 85.333 256v512A170.667 170.667 0 0 0 256 938.667h512A170.667 170.667 0 0 0 938.667 768V256A170.667 170.667 0 0 0 768 85.333H256zM170.667 256A85.333 85.333 0 0 1 256 170.667h512A85.333 85.333 0 0 1 853.333 256v512A85.333 85.333 0 0 1 768 853.333H256A85.333 85.333 0 0 1 170.667 768V256zm576 234.667a64 64 0 1 0-63.915-60.416L579.584 533.419a65.835 65.835 0 0 0-7.125 0l-82.219-82.176a64 64 0 1 0-127.147 0l-82.218 82.176a64 64 0 1 0 60.33 60.33l85.462-85.376 85.418 85.419a64 64 0 1 0 127.787 0l103.253-103.168 3.542.085z"
    />
  </svg>
);
export default SvgChartIcon;
